import { render, staticRenderFns } from "./Solicitudes.vue?vue&type=template&id=b1ba8dd0&"
import script from "./Solicitudes.vue?vue&type=script&lang=ts&"
export * from "./Solicitudes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b1ba8dd0', component.options)
    } else {
      api.reload('b1ba8dd0', component.options)
    }
    module.hot.accept("./Solicitudes.vue?vue&type=template&id=b1ba8dd0&", function () {
      api.rerender('b1ba8dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/RegistrarBajaSim/ModalProcesar/Solicitudes.vue"
export default component.exports